import { cn } from '@/lib/utils';
import { Palette, Sparkles } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  href: string;
}

interface CustomizationSidebarProps {
  activePage: string;
  onPageSelect: (page: string) => void;
  className?: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    id: 'presets',
    label: 'Template Presets',
    icon: Sparkles,
    href: '/customization/presets',
  },
  {
    id: 'themes',
    label: 'Themes',
    icon: Palette,
    href: '/customization/themes',
  },
];

function NavLink({ item, isActive }: { item: NavItem; isActive: boolean }) {
  const Icon = item.icon;

  return (
    <Link
      to={item.href}
      className={cn(
        'flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors',
        isActive ? 'bg-secondary text-secondary-foreground' : 'hover:bg-secondary/50'
      )}
    >
      <Icon className="h-4 w-4" />
      <span>{item.label}</span>
    </Link>
  );
}

export function CustomizationSidebar({
  activePage,
  onPageSelect,
  className,
}: CustomizationSidebarProps) {
  return (
    <div className={cn('w-56 border-r bg-background overflow-y-auto', className)}>
      <div className="p-4 space-y-1">
        <div className="pb-2">
          <h2 className="text-sm font-semibold text-muted-foreground uppercase">Customization</h2>
        </div>

        {NAV_ITEMS.map((item) => (
          <NavLink key={item.id} item={item} isActive={activePage === item.id} />
        ))}
      </div>
    </div>
  );
}
